import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { NavigationEnd, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { OrgService } from '../_services/org.service';
import { School } from '../dropdown-school/org.school';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { PhaseService } from '../_services/phase.service';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
	url: any;
	role: any;
	school: School;
	subscriptions: Subscription[] = [];
	selectedSchool: School;
	headerBackButton: any;
	constructor(
		public AuthenticationService: AuthenticationService,
		private router: Router,
		private jwtHelper: JwtHelperService,
		private titleService: Title,
		private phaseService: PhaseService,
		private orgService: OrgService
	) {}

	ngOnInit() {
		this.url = this.router.url;
		this.updateRoleAndBackButton();
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.url = this.router.url;
			}
			this.updateRoleAndBackButton();
		});

		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				this.selectedSchool = data;
			})
		);
	}
	private updateRoleAndBackButton() {
		if (this.AuthenticationService.isAuthenticated()) {
			const token = localStorage.getItem('currentUser');
			const decoded = this.jwtHelper.decodeToken(token);
			this.role = decoded.role;
			this.headerBackButton = this.role?.toLowerCase();
		}
	}

	logout() {
		console.log('logout');
		this.AuthenticationService.logout();
	}
	print() {
		//Print title swapping handled by org service window event listener beforeprint and afterprint.
		window.print();
	}
}
